export default __webpack_public_path__ + "images/pages/quiz/categories/desktop_skincare-a16c547d62fcf13b3d19c7f4a8a6add2.svg";